import React from 'react'
import classes from './Item.module.sass'
import { CategoryAttribute } from '../../../../types/interfaces'
import { Toggle } from '../../../newToggle/Toggle'
import add from '../../../../../assets/images/icons/add.svg'
import trash from '../../../../../assets/images/icons/trash.svg'
import up from '../../../../../assets/images/icons/arrow_up.svg'
import down from '../../../../../assets/images/icons/down.svg'
import close from '../../../../../assets/images/icons/close.svg'
import { createTypeSelectList } from '../../../../utils/functions/createTypeSelectList'
import { FieldType, Unit, ValueType } from '../../../../types/enums'
import {
  fieldTypeToText,
  unitTypeToText,
  valueTypeToInputType,
  valueTypeToText,
} from '../../../../utils/functions/enumToText'
import { maxAttributesCount, maxOptionsLength } from '../../../../utils/constants'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { Button } from '../../../button/Button'
import { useItem } from './hooks/useItem'
import { IconButton } from '../../../iconButton/IconButton'

type Props = {
  el: CategoryAttribute
  length: number
  addItem: (el: CategoryAttribute) => void
  removeItem: (el: CategoryAttribute) => void
  itemUp: (el: CategoryAttribute) => void
  itemDown: (el: CategoryAttribute) => void
  onChange: (id: string, updates: Partial<CategoryAttribute>) => void
  index: number
}

export const Item = ({
  el,
  length,
  addItem,
  removeItem,
  itemUp,
  itemDown,
  onChange,
  index,
}: Props) => {
  const dark = useSelector(selectDarkTheme)
  const { value, setValue, disabled } = useItem()

  return (
    <div className={classes.withParams}>
      <div className={classes.container}>
        <div className={classes.fields}>
          <input
            className={dark ? classes.inputDark : classes.input}
            type="text"
            placeholder="Наименование"
            value={el.name}
            onChange={(e) => onChange(String(el.id), { name: e.target.value })}
          />
          <select
            className={dark ? classes.selectDark : classes.select}
            value={el.fieldType}
            onChange={(e) =>
              onChange(String(el.id), {
                fieldType: Number(e.target.value),
                valueType: el.fieldType === FieldType.CHECKBOX ? ValueType.BOOLEAN : -1,
                isRequired: false,
                unit: -1,
                options: [],
              })
            }
          >
            {createTypeSelectList(FieldType, fieldTypeToText).map((el) => (
              <option key={el.value} value={el.value}>
                {el.label}
              </option>
            ))}
          </select>

          {el.fieldType !== FieldType.CHECKBOX && el.fieldType !== -1 && (
            <select
              className={dark ? classes.selectDark : classes.select}
              value={el.valueType}
              onChange={(e) =>
                onChange(String(el.id), {
                  valueType: Number(e.target.value),
                  unit: -1,
                  options: [],
                })
              }
            >
              {createTypeSelectList(ValueType, valueTypeToText)
                .filter(
                  (item) =>
                    ((el.fieldType === FieldType.INPUT ||
                      el.fieldType === FieldType.SELECT ||
                      el.fieldType === FieldType.MULTISELECT) &&
                      Number(item.id) !== ValueType.BOOLEAN) ||
                    (el.fieldType !== FieldType.INPUT &&
                      el.fieldType !== FieldType.SELECT &&
                      el.fieldType !== FieldType.MULTISELECT),
                )
                .map((el) => (
                  <option key={el.value} value={el.value}>
                    {el.label}
                  </option>
                ))}
            </select>
          )}
          {el.valueType === ValueType.NUMBER && (
            <select
              className={dark ? classes.selectDark : classes.select}
              value={el.unit}
              onChange={(e) =>
                onChange(String(el.id), { unit: Number(e.target.value), options: [] })
              }
            >
              {createTypeSelectList(Unit, unitTypeToText).map((el) => (
                <option key={el.value} value={el.value}>
                  {el.label}
                </option>
              ))}
            </select>
          )}
        </div>
        <div className={classes.toggleContainer}>
          <div className={classes.label}>Обязателен</div>
          <Toggle
            disabled={el.fieldType === FieldType.CHECKBOX}
            checked={el.isRequired}
            onChange={() => onChange(String(el.id), { isRequired: !el.isRequired })}
          />
        </div>
        <div className={classes.toggleContainer}>
          <div className={classes.label}>Активен</div>
          <Toggle
            checked={el.isVisible}
            onChange={() => onChange(String(el.id), { isVisible: !el.isVisible })}
          />
        </div>

        <div className={classes.buttons}>
          <IconButton
            alt="Добавить"
            icon={add}
            onClick={() => addItem(el)}
            display={length < maxAttributesCount}
            small
          />
          <IconButton
            alt="Наверх"
            icon={up}
            onClick={() => itemUp(el)}
            display={el.sortOrder !== 100 && length > 1}
            small
          />
          <IconButton
            alt="Вниз"
            icon={down}
            onClick={() => itemDown(el)}
            display={length > 1 && index !== length - 1}
            small
          />
          <IconButton alt="Удалить" icon={trash} onClick={() => removeItem(el)} display small />
        </div>
      </div>
      {(el.fieldType === FieldType.SELECT || el.fieldType === FieldType.MULTISELECT) &&
        el.valueType !== -1 && (
          <div className={classes.paramsContainer}>
            Параметры для выбора
            <div className={classes.paramsList}>
              <div className={classes.paramsAdd}>
                <input
                  className={dark ? classes.inputDark : classes.input}
                  type={valueTypeToInputType(el.valueType)}
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                />
                <Button
                  small
                  onClick={() => {
                    onChange(String(el.id), { options: [...el.options, value] })
                    setValue('')
                  }}
                  text="Добавить"
                  disabled={disabled || el.options.length === maxOptionsLength}
                />
              </div>
              {el.options.map((item, index) => (
                <div className={classes.paramsItem} key={`${item}-${index}`}>
                  {item}
                  <img
                    className={classes.paramIcon}
                    alt="Удалить"
                    src={close}
                    onClick={() =>
                      onChange(String(el.id), {
                        options: [...el.options.filter((option) => option !== item)],
                      })
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        )}
    </div>
  )
}
